export default __webpack_public_path__ + "static/media/tsunami.f8d3b1cf.svg";